// What a code can open, as picked from the select beside the destination field
// (DestinationInput). The stored destination still carries its scheme — the
// server, the public API and CSV uploads never see a "kind" — so a kind is only
// how the SPA splits a destination into a picker and a scheme-free text field.
//
// Adding a kind is one entry here plus the server's QrCode.valid_destination?
// and validateDestinationUrl in ./urls.js. `prefix` is prepended to what the
// creator types; the first kind is the default and owns every destination no
// other prefix claims.
export const DESTINATION_KINDS = [
  { id: "website", label: "Website", prefix: "",        placeholder: "yourrestaurant.com/menu", inputMode: "url" },
  { id: "email",   label: "Email",   prefix: "mailto:", placeholder: "you@yoursite.com",        inputMode: "email" },
]

// A hosted kind (#332) owns no destination string: picking it swaps the text
// field for the contact page's fields, the SPA sends those, and the server sets
// the code's destination to the page's URL. Offered only while the server says
// contact pages are on (ContactPages.on?), or on a code that already has one.
export const CONTACT_KIND = { id: "contact", label: "Contact page", hosted: true }

// The kinds a picker offers.
export function kindsFor(contactPages = false) {
  return contactPages ? [ ...DESTINATION_KINDS, CONTACT_KIND ] : DESTINATION_KINDS
}

const DEFAULT_KIND = DESTINATION_KINDS[0]

export function kindById(id) {
  return DESTINATION_KINDS.find((k) => k.id === id) || DEFAULT_KIND
}

function kindWithPrefix(value) {
  return DESTINATION_KINDS.find((k) => k.prefix && value.toLowerCase().startsWith(k.prefix))
}

// "mailto:a@b.com" → { kind: email, text: "a@b.com" }. A website shows without
// its https:// (the server adds it back); an explicit http:// stays visible,
// because dropping it would silently upgrade the destination on save.
export function splitDestination(value) {
  const v = value || ""
  const kind = kindWithPrefix(v)
  if (kind) return { kind, text: v.slice(kind.prefix.length) }
  return { kind: DEFAULT_KIND, text: v.replace(/^https:\/\//i, "") }
}

// Text typed or pasted with a scheme another kind owns ("mailto:…" into
// Website) switches the picker rather than doubling the prefix.
export function joinDestination(kind, text) {
  const claimed = kindWithPrefix(text || "")
  if (claimed) return text
  const body = kind.prefix ? (text || "").replace(/^\s+/, "") : (text || "")
  return kind.prefix + body
}
